import type { ExplorerState } from '../../discovery'

export function visibleCountLabel(shown: number, total: number): string {
  if (shown < total) {
    return `Mostrando ${shown} de ${total} resultados`
  }
  return `${total} resultados`
}

export function withVotesLabel(state: ExplorerState): string {
  switch (state.withVotes) {
    case true:
      return 'Con votaciones'
    case false:
      return 'Sin votaciones'
    default:
      return ''
  }
}
